import * as React from 'react';

import { CustomDialog } from 'components/Dialogs/CustomDialog';

import { IDriverProfile, DriverProfileForm } from '../DriverProfileForm';
import styles from './styles.module.scss';
import { CircularProgress } from '@mui/material';

type InputProps = {
  driver: IDriverProfile;
  open: boolean;
  isLoading?: boolean;
  setOpen: (open: boolean) => void;
  onSubmit: (driver: IDriverProfile) => void;
};

export const DriverProfileDialog = ({
  driver,
  open = false,
  isLoading = false,
  setOpen,
  onSubmit,
}: InputProps) => {
  const handleSubmit = (driver: IDriverProfile) => {
    onSubmit(driver);
  };

  return (
    <CustomDialog open={open} setOpen={setOpen} title="Edit Driver Profile">
      <div className={styles.root}>
        {isLoading ? (
          <CircularProgress />
        ) : (
          <DriverProfileForm driver={driver} onSubmit={handleSubmit} />
        )}
      </div>
    </CustomDialog>
  );
};
